import { A } from "@solidjs/router";
import { Show } from "solid-js";
import { isLoggedIn } from "../stores/auth";

export default function Nav() {
  return (
    <nav class="flex items-center justify-between px-4 py-3 border-b border-base-300 bg-base-100">
      <span class="text-xl font-bold tracking-tight">Verdi</span>
      <Show
        when={isLoggedIn()}
        fallback={
          <A href="/auth/login" class="link link-hover text-sm">
            Log in
          </A>
        }
      >
        <A href="/auth/logout" class="link link-hover text-sm">
          Log out
        </A>
      </Show>
    </nav>
  );
}
